export const en = {
  form: {
    shopSearchForm: {
      buttons: {
        submit: {
          label: 'Apply',
        },
      },
    },
  },
  listingPanel: {
    loading: 'loading...',
    shopsCount: '',
    shopsCount_one: '{{count}} Store',
    shopsCount_other: '{{count}} Stores',
  },
  misc: {
    storeName: '',
  },
  shopDetails: {
    services: {
      ACCOUNT_OPENING: 'Opening accounts',
      EVENTS_TICKETS: 'Events tickets',
      GIFT_VOUCHER: 'Gift Cards, Subscriptions, Vouchers',
      HORSE_RACING: 'Horse Racing',
      LOCKER: 'Locker',
      LUGGAGE_STORAGE: 'Luggage storage',
      PAYMENT_SERVICES: 'Bills payment, MAV, RAV, PAGOPA',
      PAYMENT_USERS: 'Paying users',
      PHONE_RECHARGE: 'Phone recharge',
      REFILLS: 'Recharges',
      SHIPPING: 'Shipping',
      SPORTS: 'Sports',
      SPORTS_TICKETS: 'Sports tickets',
      TOTOCALCIO: 'Totocalcio',
      VIRTUAL: 'Virtual',
      VISURE: 'Visure',
      title: 'What you will find in the store',
      types: {
        betting: 'Scommesse',
        onlineGames: 'Gioco online',
        otherServices: 'Altri servizi',
        planetPay: 'Punto vendita servizi',
      },
    },
  },
  shopTile: {},
  shopTypes: {
    BETTING: 'Betting',
    ONLINE_GAMES: 'Online games',
    OTHER_SERVICES: 'Other services',
    PLANET_PAY: 'Punto vendita servizi',
  },
  welcome: '',
};
